module.exports = __webpack_public_path__ + "static/media/step2.6c70b916.svg";